import {useCallback, useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import PreviewScreenError from "../../components/errors/previewScreen/PreviewScreenError";
import {kInternalRoutes} from "../../constants/internalRoutes";
import PreviewExerciserSideBar from "../../components/bars/previewScreens/PreviewExerciserSideBar";
import {isNullOrUndefined} from "../../services/Validator";
import {isNumber} from "chart.js/helpers";
import {get_single_problem} from "../../api/levelA";
import {getLocalItemAsJsonFromKey, kTokenKey} from "../../services/LocalStorage";
import SystemScreenLoader from "../../components/loaders/SystemScreenLoader";
import PreviewExerciserManager from "../../components/others/previewScreens/PreviewExerciserManager";

export default function PreviewExerciserScreen() {
    // Used in PreviewScreen to handle LevelA exercisers
    // preview, only accessible to admin

    // PROPERTIES
    // ---- Meta
    const location = useLocation()
    const navigate = useNavigate();
    const { identifier } = useParams();
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    // ---- Functional
    const [problem, setProblem] = useState(null)
    const [exerciserIndex, setExerciserIndex] = useState(0)
    const [isExerciserOver, setIsExerciserOver] = useState(false)

    // HOOKS
    // ---- Memorizes a function, preventing it from being redefined on every render, unless its dependencies change.
    const getSingleProblem = useCallback(() => {
        // Define
        const redirectToAuthenticationScreen = () => {
            navigate(`${kInternalRoutes.authentication}?redirect=${encodeURIComponent(location.pathname)}`)
        }

        // Defense
        // ---- Current screen URL identifier parameter
        if (isNullOrUndefined(identifier) || !isNumber(identifier) || identifier < 0) {
            setIsLoading(false)
            setError("Malformed id parameter")
            return
        }
        // ---- Get token from local storage
        const token = getLocalItemAsJsonFromKey(kTokenKey);
        if (!token) {
            redirectToAuthenticationScreen()
            return
        }

        // Perform
        // ---- Set loader on and clear potential error (retry)
        setIsLoading(true)
        setError(null)
        // ---- Api call
        get_single_problem(identifier, token)
            .then((res) => {
                setProblem(res)
                setError(null)
            }).catch((err) => {
            setError("Error in fetching single problem")
            console.error(err)
        }).finally(() => {
            setIsLoading(false)
        })
    }, [identifier, location.pathname, navigate])
    // ---- Triggered at rendering : get single LevelA problem
    useEffect(() => {
        getSingleProblem()
    }, [getSingleProblem])

    // BUILD
    if (error)
        return <PreviewScreenError goBackToHome={() => {navigate(kInternalRoutes.home)}}
                                   retryFetching={() => console.log('')} />
    if (isLoading)
        return <SystemScreenLoader />
    return (
        <div className={"animate-appearSlow bg-backgroundLight3 overflow-auto w-full h-[100svh] flex justify-start items-center"}>
            <PreviewExerciserSideBar problem={problem} />
            <PreviewExerciserManager identifier={problem?.identifier}
                                     currentIndex={exerciserIndex}
                                     setCurrentIndex={setExerciserIndex}
                                     isExerciserOver={isExerciserOver}
                                     setIsExerciserOver={setIsExerciserOver}
                                     problem={problem} />
        </div>
    )
}